<template>
  <!-- :style="bgStyle" -->
  <div class="app-bg" v-if="isCheckedDevice">
    <UaError
      v-if="UAParserCheckError"
      :UAParserCheckError="UAParserCheckError"
      :ticketUAParserCheckError="ticketUAParserCheckError"
      :deviceInfo="deviceInfo"
    ></UaError>
    <router-view v-else />

    <Loading v-if="loadingShow" :text="$t('m.loading')"></Loading>
    <alert
      :isOpen="checkDelayIsError"
      :text="$t('m.checkDelayError')"
      :ok-text="$t('m.reload')"
      :isLoading="reflushing"
      @ok="reload"
      :has-close="false"
    ></alert>
  </div>
</template>
<script>
import {
  computed,
  ref,
  onBeforeMount,
  onUnmounted,
  watch,
  inject,
  onMounted,
  nextTick,
} from 'vue'
import store from '@/store'
import Loading from '@/components/Loading.vue'
import { useRoute, useRouter } from 'vue-router'
import UAParser from 'ua-parser-js'
import { useI18n } from 'vue-i18n'
import Alert from '@/components/Alert.vue'
import UaError from '@/components/UaError.vue'

export default {
  components: {
    Loading,
    Alert,
    UaError,
  },
  setup() {
    const { t } = useI18n()

    const route = useRoute()
    const router = useRouter()
    const toast = inject('toast')
    let resizeTimer = null
    // const winHeight = ref(0);
    const getWinHeight = () => {
      // winHeight.value = window.innerHeight;
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        store.dispatch('setWinHeight', window.innerHeight)
        store.dispatch('setWinWidth', window.innerWidth)
        console.log(window.innerHeight)
      }, 200)
    }
    const loadingShow = computed(() => {
      return store.getters.loadingShow
    })
    const bgStyle = computed(() => {
      return {
        height: store.getters.winHeight + 'px',
      }
    })

    // watch(token, (val) => {
    //   if (val) {
    //     joined();
    //   }
    // });
    let appCheckDevicePromiseResolve = null
    let appCheckDevicePromiseReject = null
    const appCheckDevicePromise = new Promise((resolve, reject) => {
      appCheckDevicePromiseResolve = resolve
      appCheckDevicePromiseReject = reject
    })
    store.dispatch('setAppCheckDevicePromise', appCheckDevicePromise)

    const UAParserCheckError = ref(false)
    const ticketUAParserCheckError = ref(false)
    const deviceInfo = ref(null)

    const checkDevice = () => {
      const messageHandlers = window.webkit?.messageHandlers
      if (messageHandlers) {
        showErrorPage()
        return
      }
      const parser = new UAParser()
      const res = parser.getResult()
      if (res?.os?.name?.includes('Windows') && res?.os?.version) {
        // 对Windows版本号进行调整
        const versionNum = parseFloat(res.os.version)
        if (!isNaN(versionNum)) {
          res.os.version = String(versionNum + 1)
        }
      }
      deviceInfo.value = res
      console.log(res)
      const os = res.os.name?.toLowerCase()
      const browser = res.browser.name?.toLowerCase()
      const broswerMajor = parseInt(res.browser.major)
      const browserList = {
        windows: ['chrome', 'edge'],
        'mac os': ['chrome', 'safari'],
        android: ['chrome'],
        ios: ['safari', 'mobile safari'],
      }
      let browserListByOS = null
      switch (os) {
        case 'windows':
        case 'mac os':
        case 'android':
        case 'ios':
          browserListByOS = browserList[os]
          break
        default:
          showErrorPage()
          appCheckDevicePromiseReject({
            msg: 'os error',
            res,
          })
          return
      }
      if (!browserListByOS) {
        showErrorPage()
        appCheckDevicePromiseReject({
          msg: 'browserListByOS error',
          res,
        })
        return
      } else {
        let browserIndex = -1
        browserIndex = browserListByOS.indexOf(browser)
        if (browserIndex === -1) {
          showErrorPage()
          appCheckDevicePromiseReject({
            msg: 'browserIndex error',
            res,
          })
          return
        } else {
          const broswerMinMajorList = {
            windows: {
              chrome: 56,
              edge: 80,
            },
            'mac os': {
              chrome: 56,
              safari: 11,
            },
            android: {
              chrome: 0,
            },
            ios: {
              safari: 11,
              'mobile safari': 11,
            },
          }
          const minMajor = broswerMinMajorList[os][browser]
          if (minMajor > broswerMajor) {
            showErrorPage()
            appCheckDevicePromiseReject({
              msg: 'browserMajor error',
              res,
            })
            return
          }
        }
      }
      appCheckDevicePromiseResolve()
    }
    const showErrorPage = () => {
      nextTick(() => {
        const pageType = route.meta.pageType
        console.log(route)
        // debugger
        UAParserCheckError.value = true
        if (pageType === 'Ticket') {
          ticketUAParserCheckError.value = true
        }
      })
    }
    // 由于app.vue中的route尚未初始化完毕，所以需要在watch中检查设备
    const isCheckedDevice = ref(false)

    const checkDelayIsError = computed(() => {
      return store.getters.checkDelayIsError
    })
    const reflushing = ref(false)
    const reload = () => {
      reflushing.value = true
      // 页面刷新
      window.location.reload()
    }

    watch(route, (val) => {
      if (!isCheckedDevice.value) {
        checkDevice()
        isCheckedDevice.value = true
      }
    })
    onBeforeMount(() => {
      getWinHeight()
      window.addEventListener('resize', getWinHeight)
    })
    onMounted(() => {
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function(event) {
        event.preventDefault()
      })
      // setInterval(() => {
      //   console.log(window.innerHeight);
      // }, 1000);
    })
    onUnmounted(() => {
      window.removeEventListener('resize', getWinHeight)
    })
    return {
      bgStyle,
      loadingShow,
      isCheckedDevice,
      // 时间校验出错
      checkDelayIsError,
      reflushing,
      reload,
      // 设备
      UAParserCheckError,
      ticketUAParserCheckError,
      deviceInfo,
    }
  },
}
</script>
<style lang="less">
.app-bg {
  background-color: @mainBgColor;
  height: 100%;
}
</style>
